import store from "~/store";

const userGuard = async (to, from, next) => {
    // Навигация ждёт авторизацию в модалке, вместо редиректа на страницу входа
    await store.dispatch('auth/waitForAuth')

    const middleware = to.meta.middleware

    if (middleware === undefined) {
        next()

        return
    }

    const isAdmin = store.getters['user/hasRole'](['admin'])

    let access = isAdmin

    if (!access && middleware.permissions !== undefined) {
        access = store.getters['user/hasPermission'](middleware.permissions)
    }

    if (!access && middleware.roles !== undefined) {
        access = store.getters['user/hasRole'](middleware.roles)
    }

    if (access) {
        next()
    } else {
        next("/403")
    }
}

export {userGuard}
